module.exports = __webpack_public_path__ + "static/media/apple.2799f840.jpg";